import MirumModal from "components/MirumModal";
import Login from "pages/Login";
import React from "react";
const LogInModal = ({ show, onLoggedIn, onDidDismiss }) => {
  return (
    <MirumModal
      show={show}
      dontShowFooter={true}
      className="w-3/4"
      onDidDismiss={onDidDismiss}
    >
      <Login onLoggedIn={onLoggedIn} onDidDismiss={onDidDismiss} />
    </MirumModal>
    // <div
    //   className={`${
    //     !show ? "hidden" : null
    //   } fixed w-full h-full z-10 flex items-center justify-center top-0 left-0`}
    // >
    //   <div className="bg-white p-8">
    //     {show && <Login onLoggedIn={onLoggedIn} />}
    //   </div>
    // </div>
  );
};

export default LogInModal;
